import CustomError from './CustomError'

export default class TokenInvalidException extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
